import React, { useEffect, useState } from 'react';
import { XIcon, ShoppingCart } from 'lucide-react';
const purchases = [{
  name: 'Jessica T.',
  location: 'Austin, TX'
}, {
  name: 'Michael B.',
  location: 'Denver, CO'
}, {
  name: 'Sarah K.',
  location: 'Portland, OR'
}, {
  name: 'David R.',
  location: 'Seattle, WA'
}, {
  name: 'Amanda L.',
  location: 'Phoenix, AZ'
}, {
  name: 'Chris M.',
  location: 'San Diego, CA'
}, {
  name: 'Emily S.',
  location: 'Nashville, TN'
}, {
  name: 'Ryan P.',
  location: 'Boston, MA'
}];
export function UrgencyBanner() {
  const [visible, setVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(purchases[0]);
  useEffect(() => {
    const showPopup = () => {
      setCurrentPurchase(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      setTimeout(() => setVisible(false), 6000);
    };
    const interval = setInterval(showPopup, 12000);
    setTimeout(showPopup, 3000);
    return () => clearInterval(interval);
  }, []);
  return <>
      {visible && <div className="fixed top-4 right-4 z-50 animate-slide-in" data-id="element-217" data-mp="22mexqh6sberk">
          <div className="bg-white border-4 border-brand-gold shadow-2xl rounded-xl p-4 pr-10 max-w-xs relative" data-id="element-218" data-mp="1xo51s4d8ka4w">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-brand-petrol via-brand-gold to-brand-petrol" data-id="element-219" data-mp="1sr4wvws4hdfd"></div>
            <button onClick={() => setVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-brand-graphite transition-colors" data-id="element-220" data-mp="2qbhoqfnb6jyq">
              <XIcon className="w-4 h-4" data-id="element-221" data-mp="2ghhfc1kzusk7" />
            </button>
            <div className="flex items-start gap-3" data-id="element-222" data-mp="2ccrk8ey5ti0c">
              <div className="w-10 h-10 rounded-full bg-brand-gold/20 flex items-center justify-center shrink-0 border-2 border-brand-gold" data-id="element-223" data-mp="2cg5oxtuaq3ay">
                <ShoppingCart className="w-5 h-5 text-brand-petrol" data-id="element-224" data-mp="10xkzr1y5vtfw" />
              </div>
              <div data-id="element-225" data-mp="12fjnvokckrjv">
                <p className="font-bold text-brand-graphite text-sm" data-id="element-226" data-mp="12h4i1d2r28h7">
                  {currentPurchase.name}
                </p>
                <p className="text-xs text-gray-600 mt-0.5" data-id="element-227" data-mp="17ctkbo65m3h7">
                  {currentPurchase.location}
                </p>
                <p className="text-xs text-brand-petrol font-semibold mt-1.5" data-id="element-228" data-mp="xggho0smsfab">
                  just purchased FUNCTIONAL PRO™
                </p>
              </div>
            </div>
          </div>
        </div>}
    </>;
}